<template lang="pug">
.wrapper
  image-message(v-if="isImage"
                :message="message.file"
                :inWebchat="inWebchat"
                :senderType="senderType"
                :imgAltText="imgAltText")
  document-message(v-else
                  :attachment="message.file"
                  :url="message.file.url"
                  :inWebchat="inWebchat"
                  @link="$emit('link', $event)"
                  :senderType="senderType")
</template>

<script>
import get from 'lodash/get';
import has from 'lodash/has';
import * as log from 'loglevel';
import ImageMessage from './BaseMessage/ImageMessage.vue';
import DocumentMessage from './Document.vue';

export default {
  // File Messages currently only support images
  components: {
    ImageMessage,
    DocumentMessage,
  },
  props: {
    message: { required: true, type: Object },
    inWebchat: { required: true, type: Boolean },
    senderType: { required: true, type: String },
    imgAltText: { required: true, type: String },
  },
  computed: {
    isImage() {
      // determine by mime type
      if (has(this.message, 'file.mime')) {
        return get(this.message, 'file.mime', '').includes('image');
      }

      // Return it true as the old file message were handling only
      // image message. Ideally, This should not be touched anymore.
      log.warn('File message without mimetype');
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
